export default __webpack_public_path__ + "static/media/mineral.ce74eb00.jpeg";